export var addLastPrefixIT = function (value, date) {
    var isSunday = date.getDay() === 0;
    return "".concat(value, " scors").concat(isSunday ? 'a' : 'o');
};
export var addLastPrefixDE = function (value) { return "Letzten ".concat(value); };
export var addLastPrefixEN = function (value) { return "Last ".concat(value); };
export var addLastPrefixES = function (value) { return "El ".concat(value, " pasado"); };
export var addLastPrefixFR = function (value) { return "".concat(value, " dernier"); };
export var addLastPrefixTW = function (value) { return "".concat(value.replace(/日/g, '號')); };
export var addLastPrefixPT = function (value, date) {
    var isSaturdayOrSunday = date.getDay() === 0 || date.getDay() === 6;
    return "N".concat(isSaturdayOrSunday ? 'o' : 'a', " ").concat(value, " passad").concat(isSaturdayOrSunday ? 'o' : 'a');
};
export var addLastPrefixSA = function (value) { return "".concat(value); };
//# sourceMappingURL=addLastPrefix.js.map